import React from 'react';
import ActionMenuButton from 'shared/components/action-menu-button';
import ActionButton from 'shared/components/action-menu-button/action-button';
import ActionLink from 'shared/components/action-menu-button/action-link';

interface SubItem {
  title?: string;
  description?: string;
}

interface Props {
  subtitle?: string | number;
  name: string;
  description?: string;
  handleRemove?: () => void;
  editLink?: string;
  subItems?: SubItem[];
}

const PortfolioListItem = ({
  description,
  editLink,
  handleRemove,
  name,
  subtitle,
  subItems,
}: Props) => (
  <div className="portfolio-list-item">
    <div className="portfolio-list-item-wrapper">
      <p className="portfolio-list-item-name">{name}</p>
      {subtitle && <p className="portfolio-list-item-subtitle">{subtitle}</p>}
      {description && <p className="portfolio-list-item-description">{description}</p>}
      {subItems &&
        !!subItems.length &&
        subItems.map((subItem) => (
          <div key={subtitle + ' ' + subItem.title}>
            {subItem.title && <p className="portfolio-list-item-subtitle">{subItem.title}</p>}
            {subItem.description && (
              <p className="portfolio-list-item-description">{subItem.description}</p>
            )}
          </div>
        ))}
      {(editLink || handleRemove) && (
        <ActionMenuButton>
          {editLink && <ActionLink to={editLink}>Edit</ActionLink>}
          {handleRemove && <ActionButton onClick={handleRemove}>Remove</ActionButton>}
        </ActionMenuButton>
      )}
    </div>
  </div>
);

export default PortfolioListItem;
